import { combineReducers } from 'redux'
import vehiclesUiReducer from '../../Vehicles/Redux/Ui'
import devicesUiReducer from '../../Devices/Redux/Ui'
import configuratorUiReducer from '../../Configurator/Redux/Ui'
import breadcrumbsReducer from './Breadcrumbs'
import menuReducer from './Menu'
import themeReducer from './Theme'

export default combineReducers({
  vehicles: vehiclesUiReducer,
  devices: devicesUiReducer,
  configurator: configuratorUiReducer,
  breadcrumbs: breadcrumbsReducer,
  theme: themeReducer,
  menu: menuReducer,
})
